import { ComposeViewState } from 'owa-mail-compose-store';

export default function getInfoBarMessageIdsInCompose(viewState: ComposeViewState): string[] {
    return viewState.infoBarIds;
}
